import React, { useState, useRef, useCallback } from 'react';
import { Dialog, AppBar, Toolbar, IconButton, Typography, Box, Slide, Fab } from '@mui/material';
import { 
    Close as CloseIcon, 
    Add as ZoomInIcon, 
    Remove as ZoomOutIcon, 
    Refresh as ResetZoomIcon 
} from '@mui/icons-material';
import QuickPinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} { ...props } />;
});

export default function VisorFicherosModal({ open, onClose, archivoUrl, nombreArchivo }) {
    const esPDF = nombreArchivo.toLowerCase().endsWith('.pdf');
    const pinchZoomRef = useRef(null);
    const [escalaActual, setEscalaActual] = useState(1);

    // Captura los cambios de zoom (tanto de botones como de gestos/doble clic)
    const onUpdate = useCallback(({ x, y, scale }) => {
        setEscalaActual(scale);
        const imageElement = document.getElementById("img-visor-real");
        if (imageElement) {
            imageElement.style.transform = make3dTransformValue({ x, y, scale });
        }
    }, []);

    // Funciones manuales con lógica matemática directa sobre la escala actual
    const handleZoomIn = () => {
        if (!pinchZoomRef.current) return;
        const nuevaEscala = Math.min(escalaActual + 0.4, 10);
        pinchZoomRef.current.scaleTo({ scale: nuevaEscala, x: window.innerWidth / 2, y: window.innerHeight / 2 });
    };

    const handleZoomOut = () => {
        if (!pinchZoomRef.current) return;
        const nuevaEscala = Math.max(escalaActual - 0.4, 0.2);
        pinchZoomRef.current.scaleTo({ scale: nuevaEscala, x: window.innerWidth / 2, y: window.innerHeight / 2 });
    };

    const handleReset = () => {
        if (!pinchZoomRef.current) return;
        pinchZoomRef.current.scaleTo({ scale: 1, x: window.innerWidth / 2, y: window.innerHeight / 2 });
    };

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            PaperProps={{ sx: { backgroundColor: '#1a1a1a', overflow: 'hidden' } }}
        >
            <AppBar sx={{ position: 'relative', backgroundColor: '#2a2a2a' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {esPDF ? `Visor PDF: ${nombreArchivo}` : `Radiografía/Imagen: ${nombreArchivo}`}
                    </Typography>
                </Toolbar>
            </AppBar>
            
            <Box 
                sx={{ 
                    flex: 1, 
                    display: 'flex', 
                    flexDirection: 'column',
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    width: '100vw',
                    height: 'calc(100vh - 64px)',
                    position: 'relative',
                }}
            >
                {esPDF ? (
                    <object data={archivoUrl} type="application/pdf" width="100%" height="100%" style={{ border: 'none' }}>
                        <iframe src={archivoUrl} width="100%" height="100%" title="Visor PDF" style={{ border: 'none' }} />
                    </object>
                ) : (
                    <>
                        {/* Contenedor del zoom */}
                        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <QuickPinchZoom 
                                ref={pinchZoomRef} 
                                onUpdate={onUpdate}
                                maxScale={10}
                                minScale={0.1}
                                tapZoomFactor={1.5}
                            >
                                <img 
                                    id="img-visor-real"
                                    src={archivoUrl} 
                                    alt={nombreArchivo} 
                                    style={{ 
                                        maxWidth: '100%', 
                                        maxHeight: '100%', 
                                        objectFit: 'contain',
                                        backfaceVisibility: 'hidden',
                                        transformOrigin: '0 0' // Requerido por la librería para un paneo correcto
                                    }} 
                                />
                            </QuickPinchZoom>
                        </div>

                        {/* Barra inferior flotante */}
                        <Box 
                            sx={{ 
                                position: 'absolute', 
                                bottom: 24, 
                                display: 'flex', 
                                gap: 2, 
                                backgroundColor: 'rgba(255,255,255,0.15)', 
                                p: 1, 
                                borderRadius: '30px',
                                boxShadow: 5,
                                backdropFilter: 'blur(8px)',
                                zIndex: 2000
                            }}
                        >
                            <Fab color="info" size="small" onClick={handleZoomOut} aria-label="zoom out">
                                <ZoomOutIcon />
                            </Fab>
                            <Fab color="info" size="small" onClick={handleReset} aria-label="reset zoom">
                                <ResetZoomIcon />
                            </Fab>
                            <Fab color="info" size="small" onClick={handleZoomIn} aria-label="zoom in">
                                <ZoomInIcon />
                            </Fab>
                        </Box>
                    </>
                )}
            </Box>
        </Dialog>
    );
}